import IndustryDetailPage from './industry-detail-page'

export default IndustryDetailPage
